/**
 * TYVEXO custom cookie consent banner.
 * Talks exclusively to Shopify's Customer Privacy API (window.Shopify.customerPrivacy).
 * Does not use localStorage as a source of truth for consent state.
 */
(function () {
  if (window.__tyvexoCookieConsentInit) return;
  window.__tyvexoCookieConsentInit = true;

  var PRIVACY_POLL_INTERVAL = 150;
  var PRIVACY_MAX_ATTEMPTS = 40; // ~6s
  var API_CALL_TIMEOUT = 6000;

  var refs = {};
  var lastFocusedBeforeModal = null;
  var trapHandler = null;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    refs.banner = document.getElementById('tyvexo-cookie-banner');
    refs.bannerError = document.getElementById('tyvexo-cookie-banner-error');
    refs.modalOverlay = document.getElementById('tyvexo-cookie-modal-overlay');
    refs.modal = document.getElementById('tyvexo-cookie-modal');
    refs.modalError = document.getElementById('tyvexo-cookie-modal-error');
    refs.categorySaleOfData = document.getElementById('tyvexo-cookie-category-sale-of-data');

    if (!refs.banner || !refs.modal) return; // markup not present (feature disabled)

    bindStaticEvents();

    withPrivacyApi(function (api) {
      maybeShowBanner(api);

      document.addEventListener('visitorConsentCollected', function () {
        // Consent changed elsewhere (another tab, checkout, etc.) — stay in sync.
        withPrivacyApi(function (freshApi) {
          if (!consentIsRequired(freshApi)) {
            hideBanner();
          }
        });
      });
    });
  }

  // ---------- Shopify Customer Privacy API access ----------

  function getApi() {
    return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
  }

  function withPrivacyApi(callback, attempt) {
    attempt = attempt || 0;
    var api = getApi();

    if (api) {
      callback(api);
      return;
    }

    if (attempt === 0 && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        withPrivacyApi(callback, attempt + 1);
      });
      return;
    }

    if (attempt >= PRIVACY_MAX_ATTEMPTS) {
      console.error('TYVEXO cookie consent: Shopify Customer Privacy API did not become available.');
      return;
    }

    setTimeout(function () {
      withPrivacyApi(callback, attempt + 1);
    }, PRIVACY_POLL_INTERVAL);
  }

  function consentIsRequired(api) {
    if (typeof api.shouldShowBanner === 'function') {
      try {
        return !!api.shouldShowBanner();
      } catch (error) {
        console.error('TYVEXO cookie consent: shouldShowBanner() threw.', error);
      }
    }
    // Fallback: only treat as "required" when no decision has ever been recorded.
    var consent = readCurrentConsent(api);
    if (!consent) return false;
    return consent.marketing === '' && consent.analytics === '' && consent.preferences === '';
  }

  function readCurrentConsent(api) {
    if (typeof api.currentVisitorConsent !== 'function') return null;
    try {
      return api.currentVisitorConsent();
    } catch (error) {
      console.error('TYVEXO cookie consent: currentVisitorConsent() threw.', error);
      return null;
    }
  }

  function isSaleOfDataRegion(api) {
    if (typeof api.saleOfDataRegion !== 'function') return false;
    try {
      return !!api.saleOfDataRegion();
    } catch (error) {
      return false;
    }
  }

  function updateConsent(api, values, handlers) {
    var settled = false;

    var timeoutId = setTimeout(function () {
      if (settled) return;
      settled = true;
      handlers.onError(new Error('Timed out waiting for Shopify customer privacy response.'));
    }, API_CALL_TIMEOUT);

    try {
      api.setTrackingConsent(values, function () {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        handlers.onSuccess();
      });
    } catch (error) {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      handlers.onError(error);
    }
  }

  // ---------- Banner ----------

  function maybeShowBanner(api) {
    if (!consentIsRequired(api)) return;
    showBanner();
  }

  function showBanner() {
    refs.banner.hidden = false;
  }

  function hideBanner() {
    refs.banner.hidden = true;
    setBannerError(false);
  }

  function setBannerError(show) {
    if (!refs.bannerError) return;
    refs.bannerError.hidden = !show;
  }

  function setModalError(show) {
    if (!refs.modalError) return;
    refs.modalError.hidden = !show;
  }

  // ---------- Actions ----------

  function submitConsent(values, options) {
    options = options || {};
    withPrivacyApi(function (api) {
      updateConsent(api, values, {
        onSuccess: function () {
          setBannerError(false);
          setModalError(false);
          hideBanner();
          closeModal();
          if (typeof options.onSuccess === 'function') options.onSuccess();
        },
        onError: function (error) {
          console.error('TYVEXO cookie consent: failed to save consent.', error);
          if (refs.modal && !refs.modal.hidden) {
            setModalError(true);
          } else {
            showBanner();
            setBannerError(true);
          }
        },
      });
    });
  }

  function acceptAll() {
    var saleOfData = false;
    withPrivacyApi(function (api) {
      saleOfData = isSaleOfDataRegion(api);
      submitConsent({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: saleOfData,
      });
    });
  }

  function essentialOnly() {
    submitConsent({
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
    });
  }

  function saveCustomPreferences() {
    var values = {
      analytics: isChecked('analytics'),
      marketing: isChecked('marketing'),
      preferences: isChecked('preferences'),
      sale_of_data: refs.categorySaleOfData && !refs.categorySaleOfData.hidden ? isChecked('sale_of_data') : false,
    };
    submitConsent(values);
  }

  function isChecked(category) {
    var input = document.querySelector('[data-tyvexo-cookie-category="' + category + '"]');
    return !!(input && input.checked);
  }

  // ---------- Modal ----------

  function openModal() {
    lastFocusedBeforeModal = document.activeElement;

    withPrivacyApi(function (api) {
      prefillModal(api);
    });

    refs.modalOverlay.hidden = false;
    refs.modal.hidden = false;
    setModalError(false);

    var closeButton = refs.modal.querySelector('[data-tyvexo-cookie-close-modal]');
    trapFocus(refs.modal, closeButton || refs.modal);

    document.addEventListener('keydown', onModalKeydown);
  }

  function closeModal() {
    if (refs.modal.hidden) return;

    refs.modal.hidden = true;
    refs.modalOverlay.hidden = true;
    document.removeEventListener('keydown', onModalKeydown);
    removeTrapFocus();

    if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
      lastFocusedBeforeModal.focus();
    }
    lastFocusedBeforeModal = null;
  }

  function onModalKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeModal();
    }
  }

  function prefillModal(api) {
    var consent = readCurrentConsent(api) || {};
    setToggle('preferences', consent.preferences === 'yes');
    setToggle('analytics', consent.analytics === 'yes');
    setToggle('marketing', consent.marketing === 'yes');

    if (refs.categorySaleOfData) {
      var showSaleOfData = isSaleOfDataRegion(api);
      refs.categorySaleOfData.hidden = !showSaleOfData;
      if (showSaleOfData) {
        setToggle('sale_of_data', consent.sale_of_data === 'yes');
      }
    }
  }

  function setToggle(category, checked) {
    var input = document.querySelector('[data-tyvexo-cookie-category="' + category + '"]');
    if (input) input.checked = !!checked;
  }

  // ---------- Focus trap (self-contained, no dependency on other assets) ----------

  function getFocusable(container) {
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(selector)).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function trapFocus(container, elementToFocus) {
    removeTrapFocus();

    var focusable = getFocusable(container);
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    trapHandler = function (event) {
      if (event.key !== 'Tab') return;
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', trapHandler);
    (elementToFocus || container).focus();
  }

  function removeTrapFocus() {
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler);
      trapHandler = null;
    }
  }

  // ---------- Event wiring ----------

  function bindStaticEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;

      if (target.closest('[data-tyvexo-cookie-accept-all]')) {
        event.preventDefault();
        acceptAll();
        return;
      }

      if (target.closest('[data-tyvexo-cookie-essential-only]')) {
        event.preventDefault();
        essentialOnly();
        return;
      }

      if (target.closest('[data-tyvexo-cookie-open-preferences]') || target.closest('[data-tyvexo-cookie-reopen]')) {
        event.preventDefault();
        openModal();
        return;
      }

      if (target.closest('[data-tyvexo-cookie-save-preferences]')) {
        event.preventDefault();
        saveCustomPreferences();
        return;
      }

      if (target.closest('[data-tyvexo-cookie-close-modal]')) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (target === refs.modalOverlay) {
        closeModal();
      }
    });
  }
})();
